import { AvRefreshReasons } from "@minervaproject/avsubsystem";

import { FORUM_URL } from "config";
import { ClassroomInfoType } from "shared/types";
import {
  AvRefreshMonitoringEventType,
  PreClassCheckResultMonitoringEventType,
} from "shared/types/monitoring_event";

export const getClassDetailURL = (classInfo: ClassroomInfoType) => {
  const orgPrefix = `/orgs/${classInfo.org.short_name}`;
  return `${FORUM_URL}${orgPrefix}/app/courses/${classInfo.course.id}/sections/${classInfo.section.id}/classes/${classInfo.id}`;
};

export const getClassRecordingURL = (classInfo: ClassroomInfoType) =>
  `${getClassDetailURL(classInfo)}/review?tab=video`;

export const getObserverClassURL = (classInfo: ClassroomInfoType) => {
  const orgPrefix = `/orgs/${classInfo.org.short_name}`;
  return `${FORUM_URL}${orgPrefix}/app/classes/${classInfo.id}/observe/`;
};

export const filterPreclassChecks = (event: PreClassCheckResultMonitoringEventType) => {
  const failedTests = Object.values(event.contextData).filter(
    ({ outcome, name }) => outcome === "fail" && name !== "extension",
  );
  return failedTests.length > 0;
};

export const filterAvRefreshes = (event: AvRefreshMonitoringEventType) =>
  event.contextData.reason !== AvRefreshReasons.AV_SERVICE_REQUESTED &&
  event.contextData.reason !== AvRefreshReasons.UPDATE_SERVICE_INFO;
